import React from "react"
import styled from "styled-components"
import { graphql, StaticQuery } from 'gatsby'
import BackgroundImage from 'gatsby-background-image'
import Line from './line'
import Element from './common/element'
import Laptop from './images/laptop'

const WrapperElement = styled.div`
  display: flex;
  justify-content: center;
`

const BackgroundSection = ({ className, handle }) => (
  <StaticQuery
    query={graphql`
      query {
        desktop: file(relativePath: { eq: "bg.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1920, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => {
      const sources = [
        data.desktop.childImageSharp.fluid,
        // {
        //   ...data.desktop.childImageSharp.fluid,
        //   media: `(min-width: 920px)`,
        // },
      ]
      const items = [
        {
          key: 1,
          title: 'Experiência',
          description: 'apaixonante',
          icon: 'far fa-heart',
        },
        {
          key: 2,
          title: 'Performance',
          description: 'De alto nível',
          icon: 'far fa-bolt',
        }
      ]
      return (
        <BackgroundImage
          Tag="section"
          className={className}
          fluid={sources}
          fadeIn={false}
        >
          <div className="container"> 
            <Content>
              <div className="column">
                <div className="bggg">
                  <Title>
                    Conheça o novo
                    <UpTitle>TagPlus <SupTitle>2.0</SupTitle></UpTitle> 
                  </Title>
                  <Line width="18px" align="flex-start" />
                  <Description>
                  O TagPlus 2.0 é a nova versão do sistema, <br />100% focado na experiência do usuário.
                  </Description>
                  <ButtonWrapper>
                    
                      {items.map( item => <ItemWrapper key={item.key}>
                        <i className={item.icon} />
                        <div>
                          <ItemTitle>{item.title}</ItemTitle>
                          <ItemDescription>{item.description}</ItemDescription>

                        </div>
                       
                        
                      </ItemWrapper>)}
                  </ButtonWrapper>
                </div>
              
                
              </div>
              <div className="laptop_wrapper">
                <Laptop />
              </div>
            </Content>
            
          </div>
          <WrapperElement>
            <Element />
          </WrapperElement>
          
        </BackgroundImage>
      )
    }}
  />
)

const StyledBackgroundSection = styled(BackgroundSection)`
  width: 100%;
  height: 100%;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 1;
  padding-bottom: 0;
  @media(min-width: 705px){
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  justify-items: center;
  }

  &::after, &::before {
    opacity: 1 !important;
  }

`

const Container = styled.section`
  width: 100%;
  /* height: 1481px; */
  @media(min-width: 920px){
    height: 865px;
  }
  

  .column {
    position: relative;
    
    @media(max-width: 919px){
      align-items: center;
      order: 0;
      
      .bggg {
        text-align: center;
        display:flex;
        flex-direction: column;
        box-sizing: border-box;
        h1 {
          margin-top: 0;
          font-size: 2rem;
          text-align: center;

        }
        p {
          text-align: center;

          & + div {
            display: block;
            text-align: center;

          } 
        }
      }
    }
  }
  .laptop_wrapper {
    @media(max-width: 919px){
      margin-top: 40px;
    }
    @media(min-width: 1826px){
      position: absolute;
      width: 1015px;
      left: 416px;
      top: -40px;
    }
   
  }
 
`
const Content = styled.div`
  position: relative;
  max-width: 100%;
  padding-top: 120px;
  display: grid;
  grid-template-columns: 1fr;
  padding-top: 100px;

  @media(min-width: 920px){
    grid-template-columns: 380px 1fr;
    grid-gap: 30px;
    padding-top: 0;
    
  }
  
  /* grid-gap: 47px; */
  color: #FFF;
`
const Title = styled.h1`
  font-weight: 700;
  font-size: 2rem;
  margin-bottom: 27px;
  @media(min-width: 705px){
    font-size: 1.45rem;
  }
  
  text-align: left;
 
  @media(min-width: 705px){
    text-align: left;
    margin-top:  77px;
  }

  @media(min-width: 920px){
    margin-top: 0;

  }
  
`

const SupTitle = styled.span`
  text-align: right;
  display: block;
  position: absolute;
  right: 13px;
  top: 0;
  @media(min-width: 705px){
    font-size: 2.2rem;
  }
`

const UpTitle = styled.span`
  /* margin-top: -10px; */
  display: block;
  position: relative;
  @media(min-width: 705px){
    font-size: 5.95rem;
  }
`

const ItemWrapper = styled.li`
  display: flex;
  align-items: center;
  gap: 15px;
 i {
  color: var(--cSecondary);
  font-size: 24px;
 }
`

const ItemTitle = styled.h4`
  font-size: 1rem;
  margin: 0;
`

const ItemDescription = styled.span`
  font-size: 0.9rem;
  font-weight: 300;
`
const Description = styled.p`
  font-weight: 300;
  line-height: 25px;
  text-align: center;
  max-width: 308px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 27px;
  
  @media(min-width: 705px){
    text-align: left;
    font-size: 0.92rem;
    max-width: 100%;
    margin-left: initial;
    margin-right: initial;
  }
  br {
    display: none;
    @media(min-width: 705px){
    display: initial;
    }
  }
`
const ButtonWrapper = styled.ul`
  text-align: center;
  display: flex;
  justify-content: space-between;
  list-style: none;
  padding-left: 0;
  margin-top: 50px;
 
  @media(min-width: 705px){
    text-align: left;
    max-width: 330px;
  }
`
const Banner = ({ handle }) => (
 <Container>
  <StyledBackgroundSection handle={handle} />
 </Container>
)
export default Banner
